import React from 'react'
import styles from "../css/Preview.module.css";
import { Button } from 'react-bootstrap';

const SurveyPreview = ({
    sections,
    currentSectionIndex,
    renderCurrentQuestion,
    currentQuestionIndex,
    handlePreviousQuestion,
    isButtonDisabled,
    isSelfPreviewPage,
    nextButtonText,
    handleSubmit,
    handleNextQuestion,
  }) => {
  return (
    <>
    {sections && sections.length > 0 && (
      <div className={`${styles.section_indicator} my-3`}>
        <h4>{sections[currentSectionIndex].title}</h4>
        <h6>{sections[currentSectionIndex].description}</h6>
      </div>
    )}

    {renderCurrentQuestion()}
    <div className={styles.navigationButtons}>
      <Button
        onClick={handlePreviousQuestion}
        disabled={
          currentQuestionIndex === 0 &&
          currentSectionIndex === 0
        }
        id="nextPreviousButton"
        className={`${styles.buttonNextPrev} ${
          currentQuestionIndex === 0 &&
          currentSectionIndex === 0
            ? "invisible"
            : ""
        }`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          fill="none"
        >
          <path
            d="M0.954062 7.20414L7.70406 0.454142C7.91541 0.242797 8.20205 0.124065 8.50094 0.124065C8.79982 0.124065 9.08647 0.242797 9.29781 0.454142C9.50916 0.665486 9.62789 0.95213 9.62789 1.25102C9.62789 1.5499 9.50916 1.83655 9.29781 2.04789L4.46875 6.87508L18.25 6.87508C18.5484 6.87508 18.8345 6.99361 19.0455 7.20459C19.2565 7.41556 19.375 7.70171 19.375 8.00008C19.375 8.29845 19.2565 8.5846 19.0455 8.79558C18.8345 9.00655 18.5484 9.12508 18.25 9.12508L4.46875 9.12508L9.29594 13.9551C9.50728 14.1664 9.62601 14.4531 9.62601 14.752C9.62601 15.0508 9.50728 15.3375 9.29594 15.5488C9.08459 15.7602 8.79795 15.8789 8.49906 15.8789C8.20018 15.8789 7.91353 15.7602 7.70219 15.5488L0.952188 8.79883C0.84729 8.69417 0.764099 8.56982 0.707396 8.43293C0.650692 8.29603 0.621593 8.14927 0.621767 8.0011C0.621941 7.85292 0.651386 7.70623 0.708412 7.56947C0.765436 7.4327 0.848919 7.30855 0.954062 7.20414Z"
            fill="#367FFF"
          />
        </svg>
        Previous
      </Button>

      <Button
        disabled={isButtonDisabled || isSelfPreviewPage}
        className={styles.buttonNextPrev}
        id="nextPreviousButton"
        onClick={
          nextButtonText === "Next"
            ? handleNextQuestion
            : handleSubmit
        }
      >
        {nextButtonText}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M21.0459 12.7959L14.2959 19.5459C14.0846 19.7572 13.7979 19.8759 13.4991 19.8759C13.2002 19.8759 12.9135 19.7572 12.7022 19.5459C12.4908 19.3345 12.3721 19.0479 12.3721 18.749C12.3721 18.4501 12.4908 18.1635 12.7022 17.9521L17.5312 13.1249H3.75C3.45163 13.1249 3.16548 13.0064 2.9545 12.7954C2.74353 12.5844 2.625 12.2983 2.625 11.9999C2.625 11.7016 2.74353 11.4154 2.9545 11.2044C3.16548 10.9934 3.45163 10.8749 3.75 10.8749H17.5312L12.7041 6.04492C12.4927 5.83358 12.374 5.54693 12.374 5.24804C12.374 4.94916 12.4927 4.66251 12.7041 4.45117C12.9154 4.23983 13.2021 4.12109 13.5009 4.12109C13.7998 4.12109 14.0865 4.23983 14.2978 4.45117L21.0478 11.2012C21.1527 11.3058 21.2359 11.4302 21.2926 11.5671C21.3493 11.704 21.3784 11.8507 21.3782 11.9989C21.3781 12.1471 21.3486 12.2938 21.2916 12.4305C21.2346 12.5673 21.1511 12.6914 21.0459 12.7959Z"
            fill="#367FFF"
          />
        </svg>
      </Button>
    </div>
  </>
  )
}

export default SurveyPreview